import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-notes.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-notes.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { NoteHeadingEnum, NoteHeadingEnumLookup } from "./model/note-header.model";
import { BehaviorSubject } from "rxjs";
import { AflaModuleStrategyService } from "../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RouterParamsService } from "../../shared/services/route-params.service";
import { SelectedApplicationService } from "../../shared/services/selected-application/selected-application.service";
import { ViewApplicationNotesConstants } from "./view-application-notes.constants";
import { ViewApplicationBaseComponent } from "../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../shared/application-view.service";
import { AppControllerService } from "../../app-controller.service";
import { SharedConstants } from "../../shared/constants/shared.constants";
let ViewApplicationNotesComponent = class ViewApplicationNotesComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    appControllerService;
    selectedApplicationService;
    aflaModuleStrategyService;
    changeDetectorRef;
    routerParamsService;
    noteForm;
    dataSource = new BehaviorSubject([]);
    defaultSortColumn = { column: NoteHeadingEnum.date, direction: "desc" };
    tableHeader = NoteHeadingEnumLookup;
    getNotesObservableSubscription;
    addNotePlaceHolderText = SharedConstants.ADD_NOTE_PLACEHOLDER;
    noteCharacterLimit = 500;
    noteFormControlName = "note";
    selectedApplicationEcSubscription;
    applicationCreateServiceSelectModuleSubscription;
    stepHeader = "";
    selectedModuleNameAsObservableSubscription;
    constructor(applicationViewService, appControllerService, selectedApplicationService, aflaModuleStrategyService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.appControllerService = appControllerService;
        this.selectedApplicationService = selectedApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.noteForm = this.aflaModuleStrategyService.form.get("notesForm");
        this.subscribeToSelectedApplication();
        this.subscribeToHeader();
        this.selectedApplicationEcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    populateForm(application) {
        if (application && Array.isArray(application.notes) && application.notes.length > 0) {
            const idControl = this.noteForm.get("id");
            const notesControl = this.noteForm.get(this.noteFormControlName);
            notesControl.setValue(application.notes[application.notes.length - 1].note);
            notesControl.disable();
            idControl.setValue(application.notes[0].id);
        }
        this.changeDetectorRef.detectChanges();
    }
    loadMetadata(stepMeta) {
    }
    ngOnDestroy() {
        if (this.getNotesObservableSubscription) {
            this.getNotesObservableSubscription.unsubscribe();
        }
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationEcSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.populateForm(application);
            }
        });
    }
    handleRouteChange() {
    }
    subscribeToHeader() {
        this.selectedModuleNameAsObservableSubscription = this.applicationViewService.selectedModuleNameAsObservable.subscribe((modName) => {
            const header = `${ViewApplicationNotesConstants.STEP_TITLE}`;
            this.stepHeader =
                header[0].toUpperCase() + header.substr(1).toLowerCase();
            this.changeDetectorRef.markForCheck();
        });
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AppControllerService },
        { type: SelectedApplicationService },
        { type: AflaModuleStrategyService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationNotesComponent = __decorate([
    Component({
        selector: "app-view-application-notes",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationNotesComponent);
export { ViewApplicationNotesComponent };
